import { useContext } from "react";
import { useTranslation } from "react-i18next";
import { useFormik } from "formik";
import { AuthContext } from "../../../../context/authContext";
import { attrArrayToMap } from "../../../../helpers/utils";
import FloatingInputField from "../../../molecules/formControls/inputField/FloatingInputField";
import DefaultButton from "../../../atoms/buttons/DefaultButton";
import ChangeEmailValidation from "./validation";

const ChangeEmailForm = ({ flowType, domain, onSubmit }) => {
  const { t } = useTranslation();
  const authContext = useContext(AuthContext);
  const attrMap = attrArrayToMap(authContext.attrInfo);

  const formik = useFormik({
    initialValues: {
      email:
        flowType === "store_flow" && domain === "vestelkimlik.com"
          ? ""
          : attrMap["email"],
    },
    validationSchema: ChangeEmailValidation(t),
    onSubmit,
  });

  return (
    <form
      onSubmit={formik.handleSubmit}
      autoComplete="off"
      className="flex flex-col gap-4"
    >
      <FloatingInputField
        id="email"
        name="email"
        label={t("signUp.email")}
        required={true}
        onChange={formik.handleChange}
        onBlur={formik.handleBlur}
        value={formik.values.email}
        formikTouched={formik.touched.email}
        error={formik.errors.email}
      />
      <DefaultButton
        type="submit"
        label={t("changeProfile.submit")}
        disabled={!(formik.isValid & formik.dirty) || formik.isSubmitting}
      />
    </form>
  );
};

export default ChangeEmailForm;
